import React, { useEffect, useRef } from 'react';
import hotkeys from 'hotkeys-js';
import { setupHighlighter } from './utils/highlight';
import { getElementCodeInfo, gotoEditor, getElementInspect } from './utils/inspect';
import Overlay from './Overlay';
export var defaultHotKeys = ['control', 'shift', 'command', 'c'];
export var Inspector = function Inspector(props) {
  var keys = props.keys,
      onHoverElement = props.onHoverElement,
      onClickElement = props.onClickElement,
      disableLaunchEditor = props.disableLaunchEditor,
      children = props.children; // hotkeys-js params need string

  var hotkey = (keys !== null && keys !== void 0 ? keys : defaultHotKeys).join('+');
  /** inspector tooltip overlay */

  var overlayRef = useRef();
  var mousePointRef = useRef({
    x: 0,
    y: 0
  });

  var recordMousePoint = function recordMousePoint(_ref) {
    var clientX = _ref.clientX,
        clientY = _ref.clientY;
    mousePointRef.current.x = clientX;
    mousePointRef.current.y = clientY;
  };

  var startInspect = function startInspect() {
    var overlay = new Overlay();
    overlayRef.current = overlay;
    var stopCallback = setupHighlighter({
      onPointerOver: handleHoverElement,
      onClick: handleClickElement
    });
    overlay.setRemoveCallback(stopCallback); // inspect element immediately at mouse point

    var initPoint = mousePointRef.current;
    var initElement = document.elementFromPoint(initPoint.x, initPoint.y);
    if (initElement) handleHoverElement(initElement);
  };

  var stopInspect = function stopInspect() {
    var _a;

    (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.remove();
    overlayRef.current = undefined;
  };

  var handleHoverElement = function handleHoverElement(element) {
    var _a;

    var overlay = overlayRef.current;
    var codeInfo = getElementCodeInfo(element);
    var relativePath = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.relativePath;
    var absolutePath = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.absolutePath;

    var _getElementInspect = getElementInspect(element),
        fiber = _getElementInspect.fiber,
        name = _getElementInspect.name,
        title = _getElementInspect.title;

    (_a = overlay === null || overlay === void 0 ? void 0 : overlay.inspect) === null || _a === void 0 ? void 0 : _a.call(overlay, [element], title, relativePath !== null && relativePath !== void 0 ? relativePath : absolutePath);
    onHoverElement === null || onHoverElement === void 0 ? void 0 : onHoverElement({
      element: element,
      fiber: fiber,
      codeInfo: codeInfo,
      name: name
    });
  };

  var handleClickElement = function handleClickElement(element) {
    stopInspect();
    var codeInfo = getElementCodeInfo(element);

    var _getElementInspect2 = getElementInspect(element),
        fiber = _getElementInspect2.fiber,
        name = _getElementInspect2.name;

    if (!disableLaunchEditor) gotoEditor(codeInfo);
    onClickElement === null || onClickElement === void 0 ? void 0 : onClickElement({
      element: element,
      fiber: fiber,
      codeInfo: codeInfo,
      name: name
    });
  };

  useEffect(function () {
    document.addEventListener('mousemove', recordMousePoint, true);
    return function () {
      document.removeEventListener('mousemove', recordMousePoint, true);
    };
  }, []);
  useEffect(function () {
    var handleHotKeys = function handleHotKeys(event, handler) {
      if (handler.key === hotkey) {
        overlayRef.current ? stopInspect() : startInspect();
      } else if (handler.key === 'esc' && overlayRef.current) {
        stopInspect();
      }
    }; // https://github.com/jaywcjlove/hotkeys


    hotkeys("".concat(hotkey, ", esc"), handleHotKeys);
    /**
     * @deprecated only for debug, will remove in next version
     */

    window.__REACT_DEV_INSPECTOR_TOGGLE__ = function () {
      return overlayRef.current ? stopInspect() : startInspect();
    };

    return function () {
      hotkeys.unbind("".concat(hotkey, ", esc"), handleHotKeys);
      delete window.__REACT_DEV_INSPECTOR_TOGGLE__;
    };
  }, [hotkey]);
  return React.createElement(React.Fragment, null, children !== null && children !== void 0 ? children : null);
};